import React, { useEffect, useState } from 'react';
import { motion, useAnimate } from 'framer-motion'
import '../styles/MainProfile.css';
import PopoverContent from '../components/PopoverContent';
import { POP_OVER_STATE } from '../utils';
import { useLocation } from 'react-router-dom';

const MainProfile = () => {
	const [ popoverState, setPopoverState ] = useState(POP_OVER_STATE.NONE);
	const [ scope, animate ] = useAnimate();

	const location = useLocation();

	useEffect(() => {
		switch (location.pathname) {
			case '/coffee':
				setPopoverState(POP_OVER_STATE.CHECKOUT)
				break;
			case '/resume':
				setPopoverState(POP_OVER_STATE.RESUME)
				break;
			case '/projects':
				setPopoverState(POP_OVER_STATE.PROJECTS)
				break;
			case '/contact':
				setPopoverState(POP_OVER_STATE.CONTACT)
				break;
			default:
				setPopoverState(POP_OVER_STATE.NONE)
		}
	}, [location]);

	useEffect(() => {
		const sequence = [
			['#profile-pic-card > img', { borderRadius: '50%' }, { duration: 0 }],
			['#profile', { opacity: 1 }, { delay: 0.5, duration: 0.5 }],
			['#profile-pic-card > img', { borderRadius: '25%' }, { delay: 0.75, duration: 0.3, ease: 'easeOut' }],
		]
		animate(sequence)
	}, []);

	const onLinkClick = (newState) => {
		setPopoverState(newState)
	}

	return (
		<motion.div
			ref={scope}
			id='profile-container'
			animate={{ background: '#e3dece' }}
			transition={{ duration: 1 }}
			onClick={() => { setPopoverState(POP_OVER_STATE.NONE)}}
		>
			{popoverState !== POP_OVER_STATE.NONE ?
				<PopoverContent popoverState={popoverState} setPopoverState={setPopoverState} />
				:
				null
			}
			<div id='profile'>
				<div id='profile-pic-card'>
					<motion.img alt='' src='/img/profilePic.jpeg'/>
					<div className='profile-text'>
						Hi there, I'm Ye!
					</div>
				</div>
				<div className='profile-text'>
					I'm a full time software engineer (currently{' '}
					<motion.a
						whileHover={{color: '#fff'}}
						href='https://intuit.com' target='_blank'>@Intuit</motion.a>, ex{' '}
					<motion.a
						whileHover={{color: '#fff'}}
						href='https://squarespace.com' target='_blank'>@Squarespace</motion.a>
					), part time adjunct lecturer and,
					all things web enthusiast. Addicted to coding, ever since my first "Hello, World!" almost{' '}
					<motion.a
						tabIndex='1'
						whileHover={{color: '#fff'}}
						onClick={(e) => {
							e.stopPropagation();
							onLinkClick(POP_OVER_STATE.RESUME)
						}}
					>10+ years 🗓</motion.a> ago!
					If I'm not writing code in my free time, you can find me playing handball, video games,
					or just working out and staying active.
				</div>
				<div className='profile-text'>
					Always learning each day, and looking to taking on new challenges! I occasionally like taking on side{' '}
					<motion.a
						tabIndex='1'
						whileHover={{color: '#fff'}}
						onClick={(e) => {
							e.stopPropagation();
							onLinkClick(POP_OVER_STATE.PROJECTS)
						}}
					>projects 📚</motion.a> in my free time, so feel free to{' '}
					<motion.a
						tabIndex='1'
						whileHover={{color: '#fff'}}
						onClick={(e) => {
							e.stopPropagation();
							onLinkClick(POP_OVER_STATE.CONTACT)
						}}
					>reach out 📱</motion.a> to me if you'd like to work with me,
					I'd love to have a chat with you!
				</div>
				<div className='profile-text'>
					P.S. Buy me a cup of{' '}
					<motion.a
						tabIndex='1'
						whileHover={{color: '#fff'}}
						onClick={(e) => {
							e.stopPropagation();
							onLinkClick(POP_OVER_STATE.CHECKOUT)
						}}
					>coffee ☕️</motion.a>, and I'll be your friend for life! :)
				</div>
			</div>
		</motion.div>
	);
};

export default MainProfile;